var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconfinderTrain2875945(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "87px",
    viewBox: "0 0 87 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconfinder_train_2875945") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Signup-\\u05D1\\u05E7\\u05E9\\u05D4-\\u05E0\\u05E9\\u05DC\\u05D7\\u05D4",
    transform: "translate(-597.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card/\\u05D4\\u05E8\\u05E9\\u05DE\\u05D4",
    transform: "translate(139.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(243.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_train_2875945",
    transform: "translate(258.500000, 147.500000) scale(-1, 1) translate(-258.500000, -147.500000) translate(216.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6640625,43.1640625 L43.4296875,43.1640625 C56.84375,43.1640625 69.859375,48.2109375 79.6875,57.5078125 L82.2109375,59.8984375 C83.5390625,61.09375 84.3359375,62.953125 84.3359375,64.8125 L84.3359375,68.53125 C84.3359375,72.25 81.4140625,75.171875 77.6953125,75.171875 L0.6640625,75.171875",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6875,57.5078125 C75.703125,53.7890625 71.3203125,50.8671875 66.5390625,48.4765625 L53.125,48.4765625 C51.265625,48.4765625 49.8046875,49.9375 49.8046875,51.796875 L49.8046875,55.78125 C49.8046875,57.640625 51.265625,59.1015625 53.125,59.1015625 L81.546875,59.1015625 L79.6875,57.5078125 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    fill: "#F9BA4D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1875,59.1015625 L41.171875,59.1015625 C43.03125,59.1015625 44.4921875,57.640625 44.4921875,55.78125 L44.4921875,51.796875 C44.4921875,49.9375 43.03125,48.4765625 41.171875,48.4765625 L37.1875,48.4765625 C35.328125,48.4765625 33.8671875,49.9375 33.8671875,51.796875 L33.8671875,55.78125 C33.8671875,57.640625 35.328125,59.1015625 37.1875,59.1015625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    fill: "#F9BA4D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25,59.1015625 L25.234375,59.1015625 C27.09375,59.1015625 28.5546875,57.640625 28.5546875,55.78125 L28.5546875,51.796875 C28.5546875,49.9375 27.09375,48.4765625 25.234375,48.4765625 L21.25,48.4765625 C19.390625,48.4765625 17.9296875,49.9375 17.9296875,51.796875 L17.9296875,55.78125 C17.9296875,57.640625 19.390625,59.1015625 21.25,59.1015625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    fill: "#F9BA4D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125,59.1015625 L9.296875,59.1015625 C11.15625,59.1015625 12.6171875,57.640625 12.6171875,55.78125 L12.6171875,51.796875 C12.6171875,49.9375 11.15625,48.4765625 9.296875,48.4765625 L5.3125,48.4765625 C3.453125,48.4765625 1.9921875,49.9375 1.9921875,51.796875 L1.9921875,55.78125 C1.9921875,57.640625 3.453125,59.1015625 5.3125,59.1015625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    fill: "#F9BA4D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.3359375,
    y1: 84.3359375,
    x2: 0.6640625,
    y2: 84.3359375,
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.6640625,
    y1: 79.0234375,
    x2: 84.3359375,
    y2: 79.0234375,
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.109375,28.5546875 C57.109375,27.09375 55.9140625,25.8984375 54.453125,25.8984375 C52.9921875,25.8984375 51.796875,27.09375 51.796875,28.5546875 C50.3359375,28.5546875 49.140625,29.75 49.140625,31.2109375 C49.140625,32.671875 50.3359375,33.8671875 51.796875,33.8671875 L57.109375,33.8671875 C58.5703125,33.8671875 59.765625,32.671875 59.765625,31.2109375 C59.765625,29.75 58.5703125,28.5546875 57.109375,28.5546875 Z",
    id: "Path",
    fill: "#D8F2FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.109375,37.5546875 C77.109375,36.09375 75.9140625,34.8984375 74.453125,34.8984375 C72.9921875,34.8984375 71.796875,36.09375 71.796875,37.5546875 C70.3359375,37.5546875 69.140625,38.75 69.140625,40.2109375 C69.140625,41.671875 70.3359375,42.8671875 71.796875,42.8671875 L77.109375,42.8671875 C78.5703125,42.8671875 79.765625,41.671875 79.765625,40.2109375 C79.765625,38.75 78.5703125,37.5546875 77.109375,37.5546875 Z",
    id: "Path-Copy",
    fill: "#D8F2FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4765625,75.0390625 C15.0078125,77.296875 17.1328125,79.0234375 19.65625,79.0234375 C22.1796875,79.0234375 24.171875,77.296875 24.8359375,75.0390625 L14.4765625,75.0390625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25,75.0390625 C4.78125,77.296875 6.90625,79.0234375 9.4296875,79.0234375 C11.953125,79.0234375 13.9453125,77.296875 14.609375,75.0390625 L4.25,75.0390625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4140625,75.0390625 C47.9453125,77.296875 50.0703125,79.0234375 52.59375,79.0234375 C55.1171875,79.0234375 57.109375,77.296875 57.7734375,75.0390625 L47.4140625,75.0390625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7890625,75.0390625 C37.3203125,77.296875 39.4453125,79.0234375 41.96875,79.0234375 C44.4921875,79.0234375 46.484375,77.296875 47.1484375,75.0390625 L36.7890625,75.0390625 Z",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5703125,40.5078125 L24.5703125,39.1796875 C24.5703125,38.3828125 25.1015625,37.8515625 25.8984375,37.8515625 L36.5234375,37.8515625 C37.3203125,37.8515625 37.8515625,38.3828125 37.8515625,39.1796875 L37.8515625,40.5078125",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 17.265625)",
    stroke: "#00458A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.9921875,
    y1: 0.6640625,
    x2: 0.6640625,
    y2: 0.6640625,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.2265625,
    y1: 0.6640625,
    x2: 4.6484375,
    y2: 0.6640625,
    id: "Path"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 33.8671875,
    y1: 21.9140625,
    x2: 11.2890625,
    y2: 21.9140625,
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(62.421875, 0.000000)",
    stroke: "#00458A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 1.5,
    transform: "translate(11.289375, 11.288393) rotate(-89.744560) translate(-11.289375, -11.288393) ",
    cx: 11.2893753,
    cy: 11.2883925,
    r: 3.9844146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2890625,
    y1: 0.6640625,
    x2: 11.2890625,
    y2: 4.6484375,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2890625,
    y1: 17.9296875,
    x2: 11.2890625,
    y2: 21.9140625,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.9140625,
    y1: 11.2890625,
    x2: 17.9296875,
    y2: 11.2890625,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6484375,
    y1: 11.2890625,
    x2: 0.6640625,
    y2: 11.2890625,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.9296875,
    y1: 4.78125,
    x2: 16.0703125,
    y2: 6.640625,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5078125,
    y1: 15.9375,
    x2: 4.6484375,
    y2: 17.796875,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.796875,
    y1: 17.9296875,
    x2: 15.9375,
    y2: 16.0703125,
    id: "Path",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.640625,
    y1: 6.5078125,
    x2: 4.78125,
    y2: 4.6484375,
    id: "Path",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.6640625,
    y1: 63.75,
    x2: 80.3515625,
    y2: 63.75,
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.4,
    fill: "#FFA000",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfinderTrain2875945);
export default __webpack_public_path__ + "static/media/iconfinder_train_2875945.509fc8c52b363b8cb1dbdb8b1ccb97b6.svg";
export { ForwardRef as ReactComponent };